import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <header className="shadow-lg relative">
            <div className="container mx-auto flex justify-between items-center py-4 px-6">
                {/* Logo-Bereich */}
                <div className="flex items-center">
                    <Link className="flex" to="/">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="h-8 w-8 text-white"
                        >
                            <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
                        </svg>
                        <span className="text-white font-bold text-2xl ml-3">Cloudtal</span>
                    </Link>
                </div>

                {/* Desktop-Navigation */}
                <nav className="hidden md:block">
                    <ul className="flex space-x-8">
                        <li>
                            <Link
                                to="/products"
                                className="text-gray-300 hover:text-white transition-colors duration-200"
                            >
                                Produkte
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/pricing"
                                className="text-gray-300 hover:text-white transition-colors duration-200"
                            >
                                Preise
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/our-vision"
                                className="text-gray-300 hover:text-white transition-colors duration-200"
                            >
                                Unsere Vision
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/contact"
                                className="text-gray-300 hover:text-white transition-colors duration-200"
                            >
                                Kontakt
                            </Link>
                        </li>
                    </ul>
                </nav>

                {/* Mobile-Menu-Toggle (wird nur im Header angezeigt, wenn Overlay nicht aktiv ist) */}
                <div className="md:hidden">
                    <button onClick={toggleMenu} className="text-white focus:outline-none">
                        {!isMenuOpen && (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-8 w-8"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                        )}
                    </button>
                </div>
            </div>


            <div
                className={`md:hidden fixed top-0 left-0 w-full h-full bg-black bg-opacity-90 transform transition-transform duration-300 ease-in-out z-50 ${
                    isMenuOpen ? 'translate-x-0' : '-translate-x-full'
                }`}
            >
                <div className="container mx-auto pt-20 px-6 relative">

                    <button
                        onClick={toggleMenu}
                        className="absolute top-6 right-6 text-white focus:outline-none"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-8 w-8"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>

                    <nav>
                        <ul className="flex flex-col space-y-6">
                            <li>
                                <Link
                                    onClick={() => setIsMenuOpen(false)}
                                    to="/products"
                                    className="text-gray-300 hover:text-white text-xl transition-colors duration-200"
                                >
                                    Produkte
                                </Link>
                            </li>
                            <li>
                                <Link
                                    onClick={() => setIsMenuOpen(false)}
                                    to="/pricing"
                                    className="text-gray-300 hover:text-white text-xl transition-colors duration-200"
                                >
                                    Preise
                                </Link>
                            </li>
                            <li>
                                <Link
                                    onClick={() => setIsMenuOpen(false)}
                                    to="/our-vision"
                                    className="text-gray-300 hover:text-white text-xl transition-colors duration-200"
                                >
                                    Unsere Vision
                                </Link>
                            </li>
                            <li>
                                <Link
                                    onClick={() => setIsMenuOpen(false)}
                                    to="/contact"
                                    className="text-gray-300 hover:text-white text-xl transition-colors duration-200"
                                >
                                    Kontakt
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header;
